import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, Search } from 'lucide-react';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '100vh', padding: '40px 20px',
      background: 'var(--bg-primary, #0B1121)',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    }}>
      <div style={{ textAlign: 'center', maxWidth: 500 }}>
        <div style={{
          fontSize: 'clamp(6rem, 15vw, 10rem)', fontWeight: 800,
          color: 'var(--accent-primary, #2563EB)', lineHeight: 1,
          marginBottom: 8, letterSpacing: -4, opacity: 0.9,
        }}>
          404
        </div>
        <h1 style={{
          fontSize: 'clamp(1.5rem, 4vw, 2rem)', fontWeight: 700,
          color: 'var(--text-primary, #F8FAFC)', marginBottom: 12,
        }}>
          Page Not Found
        </h1>
        <p style={{
          fontSize: 15, color: 'var(--text-secondary, #94A3B8)',
          lineHeight: 1.7, marginBottom: 32, maxWidth: 440, marginLeft: 'auto', marginRight: 'auto',
        }}>
          The page you're looking for doesn't exist or has been moved. 
          You can go back, return home, or start a new search.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button onClick={() => navigate(-1)} style={{
            height: 44, padding: '0 24px', borderRadius: 10,
            border: '1px solid var(--border-primary, #334155)',
            background: 'var(--bg-secondary, #1E293B)',
            color: 'var(--text-primary, #F8FAFC)', cursor: 'pointer',
            fontSize: 14, fontWeight: 500, fontFamily: 'inherit',
            display: 'flex', alignItems: 'center', gap: 8,
          }}>
            <ArrowLeft size={16} /> Go Back
          </button>
          <button onClick={() => navigate('/dashboard')} style={{
            height: 44, padding: '0 24px', borderRadius: 10,
            border: 'none', background: 'var(--accent-primary, #2563EB)',
            color: '#fff', cursor: 'pointer',
            fontSize: 14, fontWeight: 600, fontFamily: 'inherit',
            display: 'flex', alignItems: 'center', gap: 8,
          }}>
            <Home size={16} /> Dashboard
          </button>
          <button onClick={() => navigate('/dashboard/search')} style={{
            height: 44, padding: '0 24px', borderRadius: 10,
            border: '1px solid var(--border-primary, #334155)',
            background: 'var(--bg-secondary, #1E293B)',
            color: 'var(--text-primary, #F8FAFC)', cursor: 'pointer',
            fontSize: 14, fontWeight: 500, fontFamily: 'inherit',
            display: 'flex', alignItems: 'center', gap: 8,
          }}>
            <Search size={16} /> New Search
          </button>
        </div>
      </div>
    </div>
  );
}
